import { Disclosure, Transition } from '@headlessui/react'
import { HiChevronDown } from "react-icons/hi";

export default function Faq({content}){
  const { question_text, answer_html } = content
  return(
    <Disclosure>
      <div className="border-b-2 border-gold">
        <Disclosure.Button className="flex justify-between w-full pb-3 text-lg text-left h4">
          {question_text}
          <HiChevronDown className="w-5 h-5 text-gold" />
        </Disclosure.Button>

        <Transition
          enter="transition duration-500 ease-out"
          enterFrom="transform scale-95 opacity-0"
          enterTo="transform scale-100 opacity-100"
          leave="transition duration-300 ease-out"
          leaveFrom="transform scale-100 opacity-100"
          leaveTo="transform scale-95 opacity-0"
        >
          <Disclosure.Panel>
            <div className="answer text-left" dangerouslySetInnerHTML={{__html: answer_html }}>
            </div>
          </Disclosure.Panel>
      </Transition>
    </div>
    </Disclosure>
  )
}

